module.exports = __webpack_public_path__ + "assets/webgl/LM.6.jpg.f57e3326.webp";